var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"my-4"},[_vm._v("Сервис работы с новостным фидом/уведомлениями")]),_c('p',[_vm._v("Для создания или редактирования новостей/уведомлений перейдите в \"Список уведомлений\"")])])
}]

export { render, staticRenderFns }